import styled from 'styled-components/macro';
import { Link } from '@yme/components/Link';
import { ADAPTIVE } from '@yme/tokens/screen';
import { INDENT } from '@yme/tokens/sizes';
import { escapeImageUrl } from '@yme/utils/common';
import { AspectRatio } from '@yme/utils/constants';
import { CLOTHING_MERCHANDISE_CARD_GRADIENT } from './constants';
export const CardWrapperStyled = styled.div `
  position: relative;

  background: ${CLOTHING_MERCHANDISE_CARD_GRADIENT},
    url(${({ imageUrl = '' }) => escapeImageUrl(imageUrl)});
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  display: flex;
  box-sizing: border-box;
  align-items: flex-end;
  padding: ${INDENT.xs};
  aspect-ratio: ${AspectRatio.RectangleLevel6};

  ${ADAPTIVE.minWidth.tablet} {
    padding: ${INDENT.sm};
  }
`;
export const LinkStyled = styled(Link) `
  text-decoration: none;
`;
